module.exports = __webpack_public_path__ + "img/Falhas nas linhas de plantio devido erradição de plantas 1.c58386a0.webp";